import { useTranslations } from 'next-intl';
import React from 'react';

import { CityDto } from '@cineamo/api/models/city/CityDto.types';

import { IconLocation16 } from '@cineamo/ui/src/icons/ic-location';

const SearchBarAutocomplete: React.FC<{
    cities: CityDto[];
    userCountryIso2: string;
    isLoading: boolean;
    isFetchingNextPage: boolean;
    hasNextPage: boolean;
    onSelectCity: (city: CityDto) => void;
    loaderRef: (node?: Element) => void;
    show: boolean;
}> = ({ cities, userCountryIso2, isLoading, isFetchingNextPage, hasNextPage, onSelectCity, loaderRef, show }) => {
    const t = useTranslations();
    if (!show) return null;

    return (
        <div className="absolute top-full left-0 right-0 mt-2 bg-[var(--background-color)] rounded-4 shadow-lg max-h-[300px] overflow-y-auto z-modal-view">
            <div className="bg-[var(--search-background-color)] text-[var(--search-on-background-color)]">
                {isLoading && cities.length === 0 && (
                    <div className="p-12">
                        <div className="h-24 animate-pulse bg-[var(--search-on-background-color)] opacity-20 rounded-4" />
                    </div>
                )}
                {cities && cities.length > 0 && (
                    <>
                        <ul>
                            {cities.map((city) => (
                                <li key={city.id}>
                                    <button
                                        className="w-full text-left px-16 py-12 hover:bg-[var(--surface-color)] transition-colors text-body-14 flex items-center gap-[14px]"
                                        onClick={() => onSelectCity(city)}>
                                        <IconLocation16 className="w-16 h-16 flex-shrink-0" />
                                        <span>
                                            {[
                                                city.iso31662?.toLowerCase() === userCountryIso2.toLowerCase() &&
                                                city.nameLocal
                                                    ? city.nameLocal
                                                    : city.name,
                                                city.adminName &&
                                                    t('showtimes-finder.search.city-admin-name', {
                                                        adminName: city.adminName
                                                    }),
                                                city.country
                                            ]
                                                .filter(Boolean)
                                                .join(', ')}
                                        </span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                        {hasNextPage && (
                            <div
                                ref={loaderRef}
                                className="p-12">
                                {isFetchingNextPage && (
                                    <div className="h-24 animate-pulse bg-[var(--search-on-background-color)] opacity-20 rounded-4" />
                                )}
                            </div>
                        )}
                    </>
                )}
                {!isLoading && cities.length === 0 && <div className="p-12 text-body-14">No cities found</div>}
            </div>
        </div>
    );
};

export default SearchBarAutocomplete;
